import Typography from 'typography';
import stAnnesTheme from 'typography-theme-st-annes';
import {
  bodyBackgroundColor,
  bodyTextColor,
  headingTextColor,
  linkColor,
  linkHoverActiveColor,
} from './colors';

stAnnesTheme.baseFontSize = '18px';
stAnnesTheme.overrideThemeStyles = ({ rhythm }, options) => ({
  'body': {
    backgroundColor: bodyBackgroundColor,
    color: bodyTextColor,
  },
  'h1': {
    color: headingTextColor,
  },
  'h2': {
    color: headingTextColor,
  },
  'h3': {
    color: headingTextColor,
  },
  'h4': {
    color: headingTextColor,
  },
  'h5': {
    color: headingTextColor,
  },
  'h6': {
    color: headingTextColor,
  },
  'a': {
    color: linkColor,
  },
  'a:hover,a:active': {
    color: linkHoverActiveColor,
  },
});

const typography = new Typography(stAnnesTheme);

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js